import { useEffect, useRef } from 'react';
import type { ITransitionProps } from '@/features/routing';
import {
  registerViewTransitionCallbacks,
  unregisterViewTransitionCallbacks,
} from '@/features/routing';
import { getTransitionDirection } from './getTransitionDirection';
import './TransitionViewport.styles.css';

interface ITransitionViewportProps {
  children: React.ReactNode;
  className?: string;
}

export const TransitionViewport = ({ children, className }: ITransitionViewportProps) => {
  const transitionViewportRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    registerViewTransitionCallbacks('transition-viewport', {
      onBeforeTransition: ({ currentPathname, nextPathname }: ITransitionProps) => {
        // Set the transition direction on the transitionViewport element for CSS targeting.
        const direction = getTransitionDirection(currentPathname, nextPathname);
        transitionViewportRef.current?.setAttribute('data-transition', direction);
      },
      onAfterTransition: () => {
        // Remove the transition direction from the transitionViewport element.
        transitionViewportRef.current?.removeAttribute('data-transition');
      },
    });

    return () => {
      unregisterViewTransitionCallbacks('transition-viewport');
    };
  }, []);

  return (
    <div className={className} ref={transitionViewportRef}>
      {children}
    </div>
  );
};
